import { normalizeWebsiteUrl } from "./websiteUrl";

export const IMAGE_MAX_AXIS = 800;

export function containedImageSize(width, height, maxAxis = IMAGE_MAX_AXIS) {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    throw new Error("Invalid image dimensions.");
  }
  const scale = Math.min(1, maxAxis / width, maxAxis / height);
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
}

export function normalizeImageValue(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";
  if (/^data:image\/(?:png|jpe?g|webp);base64,[a-z\d+/=\s]+$/i.test(trimmed)) return trimmed;
  return normalizeWebsiteUrl(trimmed);
}

export function resizeImageFile(file, maxAxis = IMAGE_MAX_AXIS) {
  return new Promise((resolve, reject) => {
    if (!file?.type?.startsWith("image/")) {
      reject(new Error("Unsupported image type."));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("The image could not be read."));
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => reject(new Error("The image could not be decoded."));
      image.onload = () => {
        try {
          const size = containedImageSize(image.naturalWidth, image.naturalHeight, maxAxis);
          const canvas = document.createElement("canvas");
          canvas.width = size.width;
          canvas.height = size.height;
          const context = canvas.getContext("2d");
          if (!context) throw new Error("Image resizing is not supported.");
          context.fillStyle = "#ffffff";
          context.fillRect(0, 0, size.width, size.height);
          context.drawImage(image, 0, 0, size.width, size.height);
          const outputType = ["image/png", "image/jpeg", "image/webp"].includes(file.type)
            ? file.type
            : "image/jpeg";
          resolve(canvas.toDataURL(outputType, 0.88));
        } catch (error) {
          reject(error);
        }
      };
      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
